import onOutOfView from 'core/DOM/onOutOfView'
import getById from 'utils/DOM/getById'
import activeMenuOption from 'core/DOM/activeMenuOption'

let lastResult
const coverageMenu = getById('coverage__menu')

function setStickyDetailsMenu(shown) {
  if (shown) {
    const $scrolledElem = $('#coverage__list')
    const scrolledTop = $scrolledElem.position().top
    const $elem = $('#coverage__menu')
    const heightElement = $elem.height()

    onOutOfView('coverage__menu', ({ lastKnownScrollPosition }) => {
      const scrolledBottom = $scrolledElem.height() + scrolledTop
      const scrollIntoElement =
        scrolledTop <= lastKnownScrollPosition &&
        lastKnownScrollPosition + heightElement <= scrolledBottom

      if (lastResult !== scrollIntoElement) {
        lastResult = scrollIntoElement

        if (scrollIntoElement) {
          coverageMenu.classList.add('sticky')
        } else {
          coverageMenu.classList.remove('sticky')
        }
      }
    })

    activeMenuOption('detail', 'coverage__menu')
  }
}

export default setStickyDetailsMenu
